import React, { useState, useMemo, useEffect } from "react";

import {
  MagnifyingGlassOutlineRegularIcon,
  XOutlineRegularIcon
} from "assets/SVGComponents";

import { CommonDashboardWrapper } from "styles/GlobalStyles";
import {
  CardFlexWrapperStyles,
  CardWrapperStyles
} from "pages/TalentUploadRequest/styled";
import {
  infoOptions,
  instagramStatusOptions,
  searchFieldOptions
} from "./data";

import Icon from "components/Icon/Icon";
import RightIconOutlineRegularIcon from "assets/SVGComponents/RightIconOutlineRegularIcon";
import { DotIcon } from "@phosphor-icons/react";

import PillButtons from "components/Buttons/PillButtons";
import CommonTable from "components/Tables/CommonTable";
import columns, { completedStatecolumns } from "./columns";

import { useCreatorsVerificationSlice } from "./slice/index";
import { getCreatorsInstagramInfo } from "./slice/selectors";
import { useDispatch, useSelector } from "react-redux";
import { TableWrapperStyles } from "pages/Users/styled";
import { CreatorsUserLogsWrapper } from "./styled";
import CreatorVerifyModal from "./CretorVerifyModal";
import Select from "components/Select/index";
import Input from "components/Input/index";

const CreatorsVerification = () => {
  const dispatch = useDispatch();
  const { actions } = useCreatorsVerificationSlice();
  const { loading, creatorsLogs, statusMeta, pagination } = useSelector(
    getCreatorsInstagramInfo
  );
  const [filteredColumns, setFilteredColumns] = useState(columns());
  const [tableFilters, setTableFilters] = useState({
    status: infoOptions[0],
    instagram_status: instagramStatusOptions[0]
  });

  const [userFilters, setUserFilters] = useState({
    search_field: "phone_number"
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  useEffect(() => {
    if (tableFilters.status.value === "completed") {
      const updatedColumns = columns(handleEdit);
      const newColumns = [
        ...updatedColumns.slice(0, -1),
        ...completedStatecolumns
      ];
      setFilteredColumns(newColumns);
    } else {
      setFilteredColumns(columns(handleEdit));
    }
  }, [tableFilters.status]);

  // handle fetch users on filter change
  useEffect(() => {
    handleUserFetch();
  }, [debouncedSearch, userFilters, tableFilters]);

  const handleUserFetch = (page = 1) => {
    dispatch(
      actions.fetchCreatorsInstagramRequest({
        status: tableFilters.status?.value || "",

        ...(tableFilters.instagram_status?.value !== "all" &&
          tableFilters.status?.value !== "pending" && {
            instagram_status: tableFilters.instagram_status?.value
          }),

        // ADD THIS
        search: debouncedSearch || "",
        search_field: userFilters.search_field,

        page,
        limit: 10
      })
    );
  };

  const statusMenuItems = useMemo(() => {
    return infoOptions
      ? infoOptions.map((option) => ({
          label: option.label,
          value: option.value
        }))
      : [];
  }, [infoOptions]);

  const handleEdit = (row) => {
    setSelectedRow({ ...row });
    setShowEditModal(true);
  };

  const handleCloseModal = () => {
    setSelectedRow(null);
    setShowEditModal(false);
  };

  return (
    <CreatorsUserLogsWrapper>
      <CommonDashboardWrapper>
        <div className="common-dashboard-wrapper">
          <h1 className="common-heading">Instagram Connect - DM Flow</h1>
        </div>

        <CardFlexWrapperStyles>
          {infoOptions.map((option) => (
            <CardWrapperStyles key={option.label}>
              <div className="card-list">
                <Icon
                  color={option.color}
                  component={DotIcon}
                  weight="fill"
                  format="outline"
                />
                <span className="card-title">{option.label}</span>
              </div>
              <p className="card-count">{statusMeta[option.value]}</p>
            </CardWrapperStyles>
          ))}
        </CardFlexWrapperStyles>

        <TableWrapperStyles>
          <div className="filter-bar">
            <div className="filter-bar-menus">
              <PillButtons
                placeholderText="Account Status"
                statusPlaceholder="statusActive"
                mainLabelText={tableFilters.status.label}
                rightIcon={<RightIconOutlineRegularIcon />}
                onSelect={(item) => {
                  setTableFilters((prev) => ({
                    ...prev,
                    status: item,
                    ...(item.value === "pending" && {
                      instagram_status: instagramStatusOptions[0]
                    })
                  }));
                }}
                menuItems={statusMenuItems}
                size="M"
                maxWidth="max-content"
                customClassName="status-width"
              />
              {tableFilters.status.value === "completed" && (
                <PillButtons
                  placeholderText="Instagram Status"
                  statusPlaceholder="statusActive"
                  mainLabelText={tableFilters.instagram_status.label}
                  rightIcon={<RightIconOutlineRegularIcon />}
                  onSelect={(item) => {
                    setTableFilters({
                      ...tableFilters,
                      instagram_status: item
                    });
                  }}
                  menuItems={instagramStatusOptions}
                  size="M"
                  maxWidth="max-content"
                  customClassName="status-width"
                />
              )}
            </div>

            <div className="search-dropdown-styles">
              <Select
                size="S"
                selectWrapperClassName="search-select"
                options={searchFieldOptions}
                value={userFilters.search_field}
                onChange={(option) =>
                  setUserFilters((prev) => ({
                    ...prev,
                    search_field: option
                  }))
                }
                placeholder="Search by"
              />

              <Input
                id="searchUser"
                type="search"
                placeholder="Search"
                leftIcon={<MagnifyingGlassOutlineRegularIcon />}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                size="S"
                className="search-input"
                rightIcon={<XOutlineRegularIcon />}
                handleClearSearch={() => setSearchTerm("")}
              />
            </div>
          </div>

          <CommonTable
            data={creatorsLogs}
            columns={filteredColumns}
            showEditModal={showEditModal}
            selectedRow={selectedRow}
            handleCloseModal={handleCloseModal}
            total_count={pagination.total}
            loading={loading}
            initialLoading={loading}
            page={pagination?.page || 1}
            limit={pagination?.limit || 10}
            tableWrapperStyles="table-wrapper-styles"
            tableClassName="table-full-view"
            onPageChange={handleUserFetch}
          />
        </TableWrapperStyles>
      </CommonDashboardWrapper>
      <CreatorVerifyModal
        show={showEditModal}
        onHide={handleCloseModal}
        rowData={selectedRow}
      />
    </CreatorsUserLogsWrapper>
  );
};
export default CreatorsVerification;
